<template>
    <div class="custom-select" :class="{ 'is-open': isOpen }" @click="toggle">
        <div class="select-trigger" :class="{ 'empty': !selectedLabel }">
            <span class="trigger-label">{{ selectedLabel || placeholder }}</span>
            <div class="icon-arrow_down"></div>
            <div class="select-label" v-if="label.length">
                {{ label }}<sup v-if="require">*</sup>
            </div>
        </div>
        <transition name="fade">
            <ul v-if="isOpen" class="select-options" @click.stop>

                <!-- Поле поиска появляется, только если опций больше 10 -->
                <li class="search-wrapper" v-if="options.length > 10">
                    <input
                        v-model="searchQuery"
                        type="text"
                        class="search-input"
                        placeholder="Search..."
                        @click.stop
                    >
                </li>

                <!-- Используем filteredOptions вместо options -->
                <li
                    v-for="(option, index) in filteredOptions"
                    :key="index"
                    class="option"
                    :class="{ 'is-selected': option.value === modelValue }"
                    @click="selectOption(option)"
                >
                    {{ option.label }}
                </li>
            </ul>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'CustomSelect',
    emits: ['update:modelValue'],
    props: {
        modelValue: [String, Number], // v-model
        options: {
            type: Array,
            required: true,
            default: () => []
        },
        placeholder: {
            type: String,
            default: 'Select...'
        },
        label: {
            type: String,
            default: ''
        },
        require: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isOpen: false,
            searchQuery: '',
        };
    },
    computed: {
        selectedLabel() {
            const selected = this.options.find(o => o.value === this.modelValue);
            return selected ? selected.label : '';
        },
        filteredOptions() {
            if( ! this.searchQuery )
                return this.options;

            const query = this.searchQuery.toLowerCase();
            return this.options.filter(option =>
                option.label.toLowerCase().includes(query)
            );
        }
    },
    methods: {
        toggle() {
            this.isOpen = !this.isOpen;
        },
        selectOption(option) {
            this.$emit('update:modelValue', option.value);
            this.isOpen = false;
            this.searchQuery = ''; // Сбрасываем поиск
        },
        closeOnClickOutside(e) {
            if (!this.$el.contains(e.target)) {
                this.isOpen = false;
            }
        }
    },
    mounted() {
        document.addEventListener('click', this.closeOnClickOutside);
    },
    beforeUnmount() {
        document.removeEventListener('click', this.closeOnClickOutside);
    }
};
</script>
